module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDEwIDEwIj48ZGVmcz48c3R5bGU+LmF7ZmlsbDojYThiMWJmO2ZpbGwtcnVsZTpldmVub2RkO308L3N0eWxlPjwvZGVmcz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIj48cGF0aCBjbGFzcz0iYSIgZD0iTTYuMTg5LDUsOS43NTQsMS40MzRBLjg0Ljg0LDAsMCwwLDguNTY2LjI0Nkw1LDMuODExLDEuNDM1LjI0NkEuODQuODQsMCwwLDAsLjI0NiwxLjQzNEwzLjgxMiw1LC4yNDYsOC41NjVBLjg0Ljg0LDAsMCwwLDEuNDM1LDkuNzUzTDUsNi4xODgsOC41NjYsOS43NTNBLjg0Ljg0LDAsMCwwLDkuNzU0LDguNTY1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCkiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/close.svg
// module id = WlY0
// module chunks = 1